import DividerWithText from '../../../../../components/DividerWithText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ColorPicker from '../../../../../components/ColorPicker';
import { permissionObj } from '../../../../../Helpers/permission';
import { useSelector } from 'react-redux';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param item
 * @param onChange
 * @returns {JSX.Element}
 */
const AttendanceColor = ({ item, onChange }) => {

    const { t } = useTranslation();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);

    return (<>
        <DividerWithText spacing='my-4' title={t('attendance_color_settings')} />
        <div className='col-3'>
            <ColorPicker
                id='clp_at_in_time'
                color={item?.inTime}
                name='inTime'
                onChange={onChange}
                title='inside_schedule'
                preview={true}
                titleInHeader={true}
                disabled={!(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_UPDATE))}
            />
        </div>
        <div className='col-3'>
            <ColorPicker
                id='clp_at_out_of_time'
                color={item?.outOfTime}
                name='outOfTime'
                onChange={onChange}
                title='outside_schedule'
                preview={true}
                titleInHeader={true}
                disabled={!(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_UPDATE))}
            />
        </div>
        <div className='col-3'>
            <ColorPicker
                id='clp_at_in_meal_time'
                color={item?.inMealTime}
                name='inMealTime'
                onChange={onChange}
                title='inMealTime'
                preview={true}
                titleInHeader={true}
                disabled={!(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_UPDATE))}
            />
        </div>
        <div className='col-3'>
            <ColorPicker
                id='clp_at_out_of_meal_time'
                color={item?.outOfMealTime}
                name='outOfMealTime'
                onChange={onChange}
                title='outOfMealTime'
                preview={true}
                titleInHeader={true}
                disabled={!(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MANAGE_SETTINGS_UPDATE))}
            />
        </div>
    </>);

}

export default AttendanceColor;
